import { FC } from 'react';
import { Icon } from '@/components/atomic/Icon';
import { ILinkProps, Link } from '@/components/Link';
import { classnames } from '@/utils/classnames';

interface BaseProps {
  children: React.ReactNode;
  shouldShowEndAdornment?: boolean;
}

export type TLinkButtonProps = BaseProps & (TButtonProps | ILinkProps);

export const LinkButton: FC<TLinkButtonProps> = ({
  children,
  className,
  shouldShowEndAdornment = true,
  ...rest
}) => {
  const commonProps = {
    className: classnames(
      'flex cursor-pointer items-center gap-x-1 text-xs font-medium text-blue-a30',
      className
    ),
  };

  if ('href' in rest) {
    return (
      <Link {...commonProps} {...rest}>
        {children}
        {shouldShowEndAdornment && <Icon icon="chevron_left" size={16} />}
      </Link>
    );
  } else {
    return (
      <button {...commonProps} {...rest}>
        {children}
        {shouldShowEndAdornment && <Icon icon="chevron_left" size={16} />}
      </button>
    );
  }
};
